import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpDigitalSignatureDialog, { DigitalSignatureDialogModeType } from "@rmp/core/components/digitalSignature/RmpDigitalSignatureDialog.vue";
import RmpSelect from "@rmp/core/components/fields/RmpSelect.vue";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { computed, Ref, ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { usePage } from "@rmp/core/composables/usePage";
import { useSelectProfileStore } from "@rmp/id/stores/selectProfile";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSelectProfile',
  setup(__props) {

const { tc } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useSelectProfileStore;
const store = useStore();
const { submit } = store;
const { profiles, selectedProfile } = storeToRefs(store);

const dialogOpened = ref(false);
const dataToBeSigned = computed(() => ({
	profileId: selectedProfile.value!.id,
	signedAt: Math.round(Date.now() / 1000)
}));

const handleSign = async (payload: File) => {
	await submit({
		id: selectedProfile.value!.id,
		payload
	});
};
const handleSubmit = () => {
	if(selectedProfile.value!.isSignatureRequired) {
		dialogOpened.value = true;
	} else {
		submit({ id: selectedProfile.value!.id });
	}
};

const {
	form,
	formReadonly,
	formDisabled,
	formSaving,
	formValid
} = useForm({ useStore }, true);

const { initialized, loading } = usePage({ useStore });

return { __sfc: true,tc, route, colors, useStore, store, submit, profiles, selectedProfile, dialogOpened, dataToBeSigned, handleSign, handleSubmit, form, formReadonly, formDisabled, formSaving, formValid, initialized, loading, RmpText, RmpBtn, RmpDigitalSignatureDialog, DigitalSignatureDialogModeType, RmpSelect, RmpSignInFormBase }
}

})